import { createSlice } from "@reduxjs/toolkit";

export interface IState {

  error: any,
};

export const initialState: IState = {

  error: {},
};

const ImageSlice = createSlice({
  name: "Image",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

  },
});

export default ImageSlice.reducer;